export default function (state) {
    state.Id = '';
    state.Name = '';
    state.OfficeId = '';
    state.OwnerLegalEntityId = '';
    state.loading = false;
}